module.exports = __webpack_public_path__ + "static/img/ic_menu5.0cf4d98a.png";